import { render, staticRenderFns } from "./MonitoringPatients.vue?vue&type=template&id=55b86b26&scoped=true"
import script from "./MonitoringPatients.vue?vue&type=script&lang=js"
export * from "./MonitoringPatients.vue?vue&type=script&lang=js"
import style0 from "./MonitoringPatients.vue?vue&type=style&index=0&id=55b86b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b86b26",
  null
  
)

export default component.exports